<template>
  <div class="hello">
    <el-row>
      <el-col :xs="24">
        <div class="box1">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="16">
              <el-carousel indicator-position="outside" :interval="5000">
                <el-carousel-item v-for="item in box1" :key="item.title">
                  <div class="bannerbox animated">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.content }}</p>
                    <el-button type="primary" round>
                      <router-link :to="{ path: `${item.url}`, query: { id: 2 } }"
                        >了解详情</router-link
                      >
                    </el-button>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </el-col>
            <el-col :xs="0" :sm="8"></el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div class="box2">
        <el-col :span="20" :offset="2">
          <el-row class="box2_row">
            <el-col :xs="24" :sm="12">
              <div class="box2_contentleft animated">
                <p class="box2_title">
                  <span>关于</span><span>东方集市App</span>
                </p>
                <p>
                  东方集市APP是神寻科技旗下创立的本地生活平台，主营涵盖了餐饮、
                  外卖、生鲜零售、酒店、休闲娱乐等多个品类的线上服务平台，商家
                  免费入驻平台获取更多的线上流量与推广渠道。平台与银联、商家多方合作、整合多方面资源帮助商家获客更轻松。
                </p>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12">
              <div class="box2_contentright animated">
                <img style="width:430px" src="../assets/13.png" alt="" />
              </div>
            </el-col>
          </el-row>
          <el-row class="box2_row">
            <el-col :xs="24" :sm="12">
              <div class="box2_contentleft1 animated">
                <img style="margin-top:32px;margin-left:-150px;width:850px" src="../assets/qixingdongtu.gif" alt="" />
              </div>
            </el-col>
            <el-col :xs="24" :sm="12">
              <div class="box2_contentright1 animated">
                <p class="box2_title">
                  <span>给用户提供</span><span>一揽子解决方案</span>
                </p>
                <p>
                  涵盖了餐饮、外卖、超市便利、酒店、休闲娱乐等多个品类的线上服务。
                </p>
                <div class="box2_contentleft1_down animated">
                  <el-row type="flex" justify="space-around">
                    <el-col :span="4">
                      <img
                        style="width: 50px"
                        src="../assets/meishi.png"
                        alt=""
                      />
                      <h4 style="color:#000000;margin-top:10px" class="pic_title">美食</h4>
                    </el-col>
                    <el-col :span="4">
                      <img
                        style="width: 50px"
                        src="../assets/chaoshibianli.png"
                        alt=""
                      />
                      <h4 style="color:#000000;margin-top:10px" class="pic_title">超市便利</h4>
                    </el-col>
                    <el-col :span="4">
                      <img
                        style="width: 50px"
                        src="../assets/jiudianzhusu.png"
                        alt=""
                      />
                      <h4 style="color:#000000;margin-top:10px" class="pic_title">酒店住宿</h4>
                    </el-col>
                  </el-row>
                  <el-row type="flex" justify="space-around">
                    <el-col :span="4">
                      <img
                        style="width: 50px"
                        src="../assets/xiuxianyule.png"
                        alt=""
                      />
                      <h4 style="color:#000000;margin-top:10px" class="pic_title">休闲娱乐</h4>
                    </el-col>
                    <el-col :span="4">
                      <img
                        style="width: 50px"
                        src="../assets/fuwu.png"
                        alt=""
                      />
                      <h4 style="color:#000000;margin-top:10px" class="pic_title">服务</h4>
                    </el-col>
                    <el-col :span="4">
                      <img
                        style="width: 50px"
                        src="../assets/chuxing.png"
                        alt=""
                      />
                      <h4 style="color:#000000;margin-top:10px" class="pic_title">出行</h4>
                    </el-col>
                  </el-row>
                  <el-button type="primary" round>
                      <router-link style="color:#000000" :to="{ path: '/download', query: { id: 2 } }"
                        >了解详情</router-link
                      >
                    </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
         
        </el-col>
      </div>
    </el-row>

  </div>
</template>

<script>
export default {
  data() {
    return {
      
   

      box1: [
		{
          title: "一站式本地生活平台，打造百花多样生活",
          content:
            "东方集市聚焦“零售 + 科技”战略，和广大商户与各类合作伙伴一起，努力为消费者提供品质生活，推动商品零售和服务零售在需求侧和供给侧的数字化转型。拉动就业机会，坚持以用户为中心，更好承担社会责任，更多创造社会价值，与广大合作伙伴一起发展共赢。",
          url:"/download"
        },
        {
          title: "东方集市商家端上线#快速通道#",
          content: "成本不变，提高收入，助力万千商户共度疫情。",
          url:"/business"
        },
        
      ],
    };
  },
  methods: {
    beforeEnter: function (val) {
      console.log(val, "before enter");
    },
    enter: function (val) {
      console.log("enter");
    },
    jqfun: function () {
      function scrollnumber(element, cssname, offset) {
        var a, b, c, d;
        d = $(element).offset().top;
        a = eval(d + offset);
        b = $(window).scrollTop();
        c = $(window).height();
        if (b + c > a) {
          $(element).addClass(cssname);
        }
      }

      function scrollfun() {
        scrollnumber(".bannerbox", "fadeInLeft slow", 100);
        scrollnumber(".box2_contentleft", "fadeInLeft slow", 100);
        scrollnumber(".box2_contentleft1", "fadeInLeft slow", 100);
        scrollnumber(".box2_contentleft2", "fadeInLeft slow", 100);

        scrollnumber(".box2_contentleft1_down", "fadeInUp delay-1s", 100);
        scrollnumber(".box2_contentleft2_down", "fadeInUp delay-1s", 100);

        scrollnumber(".box2_contentright", "fadeInRight slow", 100);
        scrollnumber(".box2_contentright1", "fadeInRight slow", 100);
        scrollnumber(".box2_contentright2", "fadeInRight slow", 100);

        scrollnumber(".elcarouselbox", "slideInUp slower", 100);

        scrollnumber(".card1", "slideInUp slow", 100);
        scrollnumber(".card2", "slideInUp slow", 100);
        scrollnumber(".card3", "slideInUp slow", 100);

        scrollnumber(".box5 img", "fadeInUpBig slow", 100);
      }

      $(document).ready(function (e) {
        scrollfun();
        $(window).scroll(function () {
          scrollfun();
        });
      });
    },
  },
  /* 钩子函数 */
  beforeCreate: function () {
    //创建前状态
  },
  create: function () {
    //创建完毕状态
  },
  beforeMount: function () {
    //挂载前状态
  },
  mounted: function () {
    //挂载结束状态
    window.addEventListener("scroll", this.scrollnumber);
  },
  beforeUpdate: function () {
    //更新前状态
  },
  uptated: function () {
    //更新完成状态
  },
  beforeDestroy: function () {
    //销毁前状态
  },
  destroyed: function () {
    //销毁完成状态
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}




/* box1 */
.box1 {
  margin: 0;
  height: 800px;
  width: 100%;
  background: url(../assets/3917_jdbaxb26.jpg) no-repeat center center;
  overflow: hidden;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  
}

.box1 p {
	width:70%;
	margin-left: 15%;
}

.box1 .el-row {
  padding-top: 150px;
}

.box1 a:-webkit-any-link {
  color: #ffffff;
}

/* box2 */
.box2 {
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #000000;
  background: url(../assets/3917_jdbbe20e.png) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.box2 .box2_row {
  margin: 100px auto;
}

.box2 .el-main {
  line-height: 10px;
}

.box2 img {
  width: 80%;
}

.box2 .box2_title span {
  font-size: 24px;
  color: #cf9236;
  font-weight: 700;
}

.box2 .box2_title span:first-child {
  color: #000000;
}

.box2 .box2_list,
.box2 .box2_list li {
  float: left;
  margin: 20px 42px;
}

.pic_title {
  color: #cf9236;
  
}

.pic_title_a {
  font-size: 30px;
  font-weight: 800;
}

.box2 p {
  color: #000000;
}

/* box3 */
.box3 {
  padding-top: 200px;
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #ffffff;
  background: url(../assets/1587_jgzx3s67.png) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.box3 .box3_title {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
}

.box3 .box3_title span {
  color: #cf9236;
}

.box3 .box3_content {
}

.box3 .box3_carousel {
  margin-top: 50px;
}

.box3 .el-carousel__mask {
  opacity: 0;
  border-radius: 10px;
}

.box3 .el-carousel__item {
  background-color: #ffffff;
  border-radius: 10px;
  color: #000000;
}

.box3 .el-carousel__item button {
  border: #5a8e8e;
  color: #5a8e8e;
}

.box3 .el-carousel__item .el-row {
  padding-top: 30px;
}

/* box4 */
.box4 {
  padding-top: 50px;
}

.box4_left {
  padding-top: 100px;
}

.box4_left p {
  color: #000000;
}

.box4_left p span {
  color: #cf9236;
}

.el-card {
  /* margin: 30px auto; */
}

/* box5 */
.box5 {
  padding-top: 358px;
  padding-bottom: 50px;
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #ffffff;
  background: url(../assets/1587_jgzx3s67.png) 100% 100% no-repeat;
  background-position: 0 -10%;
}

.box5 img {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue